import styled from "styled-components";
import { useDispatch } from "react-redux";
import { AppModuleLayout } from "@layouts";
import {
    PATH_BOOKING,
    PATH_COMMISSION_AGENT,
    PATH_FAVORITES,
    PATH_MY_ACCOUNT,
    PATH_QUOTES,
    PATH_UPDATE_PASSWORD,
} from "@routes";
import { IModelAccountSetting } from "@interfaces";
import { IconUser, StyledItemAccount, StyledItemAccountLogout, SwitchCommon } from "@components";
import {
    AppDispatch,
    loadAccountDetail,
    selectAccount,
    store,
    useAppSelector,
    getMetaData,
} from "@redux";
import { useState, useEffect } from "react";
import { useLogoutHandler } from "@utilities";
import { pointsApi } from "@api";

export const AccountSetting = () => {
    const { metadata } = useAppSelector(selectAccount);
    const isOrderTabEnabled = Boolean(metadata?.is_order_tab_enabled);
    const model: IModelAccountSetting[] = [
        {
            iconComponent: <IconUser />,
            title: "Update My Details",
            link: PATH_MY_ACCOUNT,
        },
        {
            icon: "/images/userInfo/fi_heart.png",
            title: "My favourites",
            link: PATH_FAVORITES,
        },
        {
            icon: "/images/userInfo/fi_file-text.png",
            title: "Bookings",
            link: PATH_BOOKING,
        },
        {
            icon: "/images/userInfo/SAVE-CART.png",
            title: isOrderTabEnabled ? "Orders" : "Quotes",
            link: PATH_QUOTES,
        },
        {
            icon: "/images/userInfo/lock.png",
            title: "Update Password",
            link: PATH_UPDATE_PASSWORD,
        },
        // {
        //     icon: "/images/userInfo/chain.svg",
        //     title: "Link Agent Account",
        //     link: PATH_LINK_AGENT_ACCOUNT,
        // },
        {
            icon: "/images/userInfo/fi_log-out.png",
            title: "Logout",
            link: "",
        },
    ];

    const dispatch = useDispatch<AppDispatch>();
    const { account } = useAppSelector(selectAccount);

    useEffect(() => {
        dispatch(loadAccountDetail());
    }, []);

    useEffect(() => {
        if (account?.is_agent_integrated && !metadata) {
            dispatch(getMetaData());
        }
    }, [account?.is_agent_integrated, metadata, dispatch]);

    const isPointsDisplayed = Boolean(account?.is_points_displayed);
    const [checked, setChecked] = useState<boolean>(isPointsDisplayed);
    const [isPointsLoading, setPointsLoading] = useState<boolean>(false);

    useEffect(() => {
        setChecked(isPointsDisplayed);
    }, [isPointsDisplayed]);

    const handleToggle = async (nextChecked: boolean) => {
        if (isPointsLoading) return;
        const previous = checked;
        setChecked(nextChecked);
        setPointsLoading(true);
        try {
            const res = await pointsApi.showHidePoints();
            if (res.data.code === 200) {
                await dispatch(loadAccountDetail());
            }
        } catch (err) {
            setChecked(previous);
            console.error("Failed to toggle points visibility:", err);
        } finally {
            setPointsLoading(false);
        }
    };
    const handleLogout = useLogoutHandler();

    const loading = store.getState().loading.isLoading;

    return (
        <AppModuleLayout>
            {loading ? (
                ""
            ) : (
                <Wrapper>
                    <div className="menu">
                        {account?.is_agent_integrated &&
                            (metadata?.is_commission_agent || metadata?.is_points_agent) && (
                                <StyledItemPoints>
                                    <div className="point">
                                        <div className="icon">
                                            <img src="/images/Reward1.svg" alt="gift" />
                                        </div>
                                        <div className="text">
                                            {metadata?.is_commission_agent
                                                ? "Show Commissions"
                                                : "Show Points"}
                                        </div>
                                    </div>
                                    <SwitchCommon
                                        isChecked={checked}
                                        setIsChecked={(v) => {
                                            if (isPointsLoading) return;
                                            handleToggle(v);
                                        }}
                                    />
                                </StyledItemPoints>
                            )}
                        {account?.is_agent_integrated &&
                            !metadata?.is_commission_agent &&
                            metadata?.is_upgrade_to_commission_enabled && (
                                <StyledItemAccount to={PATH_COMMISSION_AGENT}>
                                    <div className="icon">
                                        <img src="/images/Reward1.svg" alt="gift" />
                                    </div>
                                    <div className="text">Upgrade to Commission agent</div>
                                </StyledItemAccount>
                            )}
                        {model.map((item, index) => {
                            if (account?.sso_type !== "email" && item.title === "Update Password") {
                                return null;
                            }
                            return item.title !== "Logout" ? (
                                <StyledItemAccount key={index} to={item.link}>
                                    <div className="icon">
                                        {item.icon ? (
                                            <img src={item.icon} alt="" />
                                        ) : (
                                            item.iconComponent
                                        )}
                                    </div>
                                    <div className="text">{item.title}</div>
                                </StyledItemAccount>
                            ) : null;
                        })}
                        {model.map((item, index) => {
                            return item.title === "Logout" ? (
                                <StyledItemAccountLogout key={index} onClick={handleLogout}>
                                    <div className="icon">
                                        <img src={item.icon} alt="" />
                                    </div>
                                    <div className="text">{item.title}</div>
                                </StyledItemAccountLogout>
                            ) : null;
                        })}
                    </div>
                </Wrapper>
            )}
        </AppModuleLayout>
    );
};

const Wrapper = styled.div`
    padding: 40px;
    padding-bottom: 80px;

    .menu {
        & > a:first-child {
            padding-top: 0;
            padding-bottom: 32px;
        }

        & > div {
            border-bottom: none;
        }
    }
`;

const StyledItemPoints = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 32px 0;
    border-bottom: 1px solid ${(props) => props.theme.colors.gray_5} !important;
    font-size: 18px;
    font-weight: 500;
    line-height: 23px;
    align-items: center;
    color: ${(props) => props.theme.colors.black};

    .icon {
        margin-right: 17px;
        display: flex;
        align-items: center;
    }
    .point {
        display: flex;
        align-items: center;
    }
`;
